import { DollarSign, Hash, Percent, Star } from 'lucide-react';
import { useRecordContext, useTranslate } from 'ra-core';
import { cn } from '../../lib/utils';
import { KPI_FORMAT } from './types';

export const KpiFormat = () => {
  return (
    <span className="flex items-center gap-1.5">
      <KpiFormatIcon />
      <KpiFormatName />
    </span>
  );
};

export const KpiFormatName = () => {
  const kpiFormat = useRecordContext<KPI_FORMAT>();
  const translate = useTranslate();

  if (!kpiFormat) return null;

  return translate(`moonstar.kpis.format.${kpiFormat.id}`);
};

export const KpiFormatIcon = ({ className }: { className?: string }) => {
  const kpiFormat = useRecordContext<KPI_FORMAT>();

  if (!kpiFormat) return null;

  const iconClassName = cn('size-4 shrink-0', className);

  switch (kpiFormat.id) {
    case 'number':
      return <Hash className={iconClassName} aria-hidden />;
    case 'percentage':
      return <Percent className={iconClassName} aria-hidden />;
    case 'star_rating':
      return <Star className={iconClassName} aria-hidden />;
    case 'currency':
      return <DollarSign className={iconClassName} aria-hidden />;
  }
};
